import styled from 'styled-components';

export const StyledDynamicSection = styled.div`
  .dynamicSection {
    width: 100%;
  }
  .user-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: white;
    border-radius: 8px;
    width: 100%;
    box-sizing: border-box;
    position: relative;
  }

  .user-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    color: #ccc;
    display: flex;
    align-items: center;
    justify-content: center;

    span.utility-icon {
      font-size: 40px;
    }
  }

  .user-info {
    display: flex;
    flex-direction: column;
  }

  .user-name {
    font-weight: 600;
    font-size: 14px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .check {
    margin-left: 4px;
  }

  .user-sub {
    font-size: 12px;
    color: #a0b3c2;
    display: flex;
  }

  .user-right {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .saved {
    background: #477d00;
    color: #c1edaf;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 12px;
  }
  .missing-info {
    background: #d13438;
    color: #ffffff;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 12px;
  }

  .delete-btn {
    background: transparent;
    border: none;
    color: white;
    cursor: pointer;
  }

  @media (max-width: 600px) {
    .user-card {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
      padding-right: 35px;
    }

    .user-right {
      width: 100%;
      justify-content: space-between;
    }
  }
  .accordion__container .accordion__heading .accordion__title {
    width: 100%;
  }
  .accordion__container .accordion__heading .accordion__title p {
    text-align: left;
  }
  .button-background-none {
    background: none;
  }
  .icon-check {
    font-size: 18px;
    color: #477d00;
  }
  .icon-alert {
    font-size: 18px;
    color: #d13438;
  }
  .icon-delete:before {
    font-size: 28px;
  }
  .dynamic-add-section {
    .accordion__container {
      border: 1px solid rgb(100, 100, 100);
      border-radius: 10px;
      margin-bottom: 15px;
      padding: 0 15px !important;
      .seperator {
        display: none;
      }
    }
  }
  .acc-delete-btn {
    background: none;
    color: var(--t-brand-fg-color);
    @media (max-width: 600px) {
      position: absolute;
      top: 37%;
      right: 0;
    }
  }
  .success-msg {
    background-color: rgba(193, 237, 175, 0.05);
    border-radius: 10px;
    .accordion__container {
      border-color: #477d00 !important;
    }
    .avatar {
      span {
        color: #477d00;
      }
    }
  }
`;
